import { BrowserRouter, Route, Switch } from 'react-router-dom'

import CategoriesList from 'pages/CategoriesList'
import Detail from 'pages/Detail'
import HB3Storage from 'pages/HB3Storage'
import HB3StorageArchive from 'pages/HB3Storage/Archive'
import HB3StorageExpanding from 'pages/HB3Storage/Expanding'
import HB3StorageFormating from 'pages/HB3Storage/Formating'
import HB3StorageInstallation from 'pages/HB3Storage/Installation'
import Navigation from 'pages/Navigation'
import PageNotFound from 'pages/PageNotFound'
import Quickstart from 'pages/Quickstart'
import Recommend from 'pages/Recommend/Solution'
// import HB3StorageExpanding from 'pages/HB3Storage/Expanding'
// import HB3StorageInstallation from 'pages/HB3Storage/Installation'
// import HB3StorageFormating from 'pages/HB3Storage/Formating'
// import HB3StorageArchive from 'pages/HB3Storage/Archive'

import { NavigationBar, ScaledViewport, useFixCookie, getNativeInfo } from '@docs/common'
import { getClientEnv } from 'common/util'

import axios from 'axios'
import { useEffect, useState } from 'react'

const modules = import.meta.glob('./pages/**/routes.{js,jsx,ts,tsx}', { eager: true })

const routes = Object.values(modules)
  .map(m => m.default || m)
  .reduce((a, b) => [].concat(a, b))
  .map((v, index) => {
    return <Route key={v.path || v.name || index} {...v} />
  })

function App() {
  const [serviceEnv, setServiceEnv] = useState(null)
  const { isReady } = useFixCookie()
  const isPr =  getClientEnv("REACT_APP_DEPLOY_ENV") === "pr"

  useEffect(() => {
    setTimeout(() => {
      if (!window.__IS_APP__) {
        window.__SANDBOX = true
      }
    }, 300)
  }, [])
  // 获取服务端的环境变量存储在 sessionStorage 中，以便客户端获取
  useEffect(() => {
    // 调用接口获取环境变量
    if (window.sessionStorage.getItem('ENVS')) {
      // start_ai_generated
      const envs = window.sessionStorage.getItem('ENVS')
      if (envs) {
        setServiceEnv(JSON.parse(envs))
      }
      // end_ai_generated
      return
    }
    axios.get('/config').then(res => {
      window.sessionStorage.setItem('ENVS', JSON.stringify(res.data))
      const envs = window.sessionStorage.getItem('ENVS')
      if (envs) {
        setServiceEnv(JSON.parse(envs))
      }
    })
  }, [])

  const renderVConsole = () => {
    import("vconsole").then((m) => {
      const VConsole = m.default
      new VConsole()
    })
  }

  useEffect(() => {
    if (!serviceEnv) {
      return
    }
    if (isPr) {
      if (
        window.location.search?.indexOf("DEBUG=1") > -1 ||
        window.sessionStorage.getItem("DEBUG") === "1"
      ) {
        renderVConsole()
      } else {
        getNativeInfo().then((res) => {
          // email以anker.com anker-in.com结尾的才显示vconsole
          if (
            ["anker.com", "anker-in.com", "anker.io"].includes(
              res?.email.split("@")[1]
            )
          ) {
            renderVConsole()
          }
        })
      }
    } else {
      if (
        /^https?:\/\/(192|127|10|172)\.\d+\.\d+\.\d+/.test(
          window.location.origin
        ) ||
        /(-eu)?-(s)?qa(\d)*\.eufylife\.com$/.test(window.location.hostname) ||
        /(-eu)?-(s)?qa(\d)*\.eufy\.com$/.test(window.location.hostname)
      ) {
        renderVConsole()
      }
    }
  }, [isPr, serviceEnv])
  return serviceEnv && isReady ? (
    <div className="App">
      <NavigationBar />
      <ScaledViewport />
      <BrowserRouter>
        <Switch>
          {routes}
          <Route component={Navigation} path="/navigation" />
          <Route component={Detail} path="/detail/:id" />

          <Route component={HB3Storage} path="/hb3storage/guide" />
          <Route component={HB3StorageExpanding} path="/hb3storage/expanding" />
          <Route component={HB3StorageInstallation} path="/hb3storage/installation" />
          <Route component={HB3StorageFormating} path="/hb3storage/formating" />
          <Route component={HB3StorageArchive} path="/hb3storage/archive" />
          <Route component={HB3StorageArchive} path="/hb3storage/archive" />
          <Route component={Recommend} path="/recommend/solution/:uid" />

          {/* <Route component={HB3StorageExpanding} path="/hb3storage/expanding" />
          <Route component={HB3StorageInstallation} path="/hb3storage/installation" />
          <Route component={HB3StorageFormating} path="/hb3storage/formating" />
          <Route component={HB3StorageArchive} path="/hb3storage/archive" /> */}
          <Route component={CategoriesList} path="/categorypage" />
          <Route component={Quickstart} path="/quickstart" />

          <Route component={PageNotFound} />
        </Switch>
      </BrowserRouter>
    </div>
  ) : null
}

export default App
